import CityLandingPage from './page';

const aracajuData = {
  cityName: 'Aracaju',
  state: 'SE',
  slug: 'palestra-silenciosa-aracaju',
  coordinates: {
    lat: -10.9472,
    lng: -37.0731,
  },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa aracaju',
    'silent conference aracaju',
    'aluguel fones sem fio sergipe',
    'eventos corporativos aracaju',
    'tradução simultânea aracaju',
    'festa silenciosa aracaju',
  ],
  heroTitle: 'palestra silenciosa aracaju',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências multilíngues e workshops em Aracaju. Transforme seu evento com nossa solução inovadora de palestra silenciosa.',
  localStats: {
    clients: '80+',
    satisfaction: '97%',
  },
  localTestimonials: [],
  localFAQs: [
    {
      question: 'Vocês atendem toda a região metropolitana de Aracaju?',
      answer: 'Sim! Atendemos toda a Grande Aracaju, incluindo Nossa Senhora do Socorro, Barra dos Coqueiros, São Cristóvão e região. Nossa equipe está pronta para atender rapidamente qualquer localidade da região metropolitana.',
    },
    {
      question: 'Qual o prazo de antecedência para contratar em Aracaju?',
      answer: 'Recomendamos reservar com pelo menos 2 semanas de antecedência para eventos em Aracaju. Para grandes conferências e eventos de maior porte, sugerimos 1 mês de antecedência. Consulte-nos sobre disponibilidade para demandas urgentes.',
    },
    {
      question: 'Vocês oferecem suporte técnico durante eventos em Aracaju?',
      answer: 'Com certeza! Todos os nossos pacotes em Aracaju incluem técnico especializado presente durante todo o evento. Garantimos funcionamento perfeito do início ao fim, com suporte imediato para qualquer necessidade que surgir.',
    },
    {
      question: 'Quantos fones sem fio vocês disponibilizam para eventos em Aracaju?',
      answer: 'Nosso estoque atende desde eventos pequenos (30 fones) até grandes conferências em Aracaju (300+ fones). Trabalhamos com equipamentos de última geração e sempre mantemos backup disponível para total segurança do seu evento.',
    },
    {
      question: 'A palestra silenciosa funciona em locais abertos em Aracaju, como na Orla?',
      answer: 'Sim! Nossos equipamentos funcionam perfeitamente em ambientes abertos em Aracaju, incluindo eventos na Orla de Atalaia e outros espaços ao ar livre. O alcance dos transmissores é de até 100 metros sem obstáculos, ideal para eventos em jardins, praias e terraços.',
    },
  ],
  seoTitle: 'Aracaju Palestra Silenciosa | Aluguel Fones Sem Fio SE | STIB',
  seoDescription: 'Palestra silenciosa Aracaju: aluguel de fones sem fio para eventos corporativos, conferências e workshops em Sergipe. Tecnologia premium com equipe enviada de São Paulo. Solicite orçamento!',
};

export default function AracajuLandingPage() {
  return <CityLandingPage cityData={aracajuData} />;
}